<template lang="pug">
div
  section
    AppTitle.u-mb-sm(:title="$t('mantra')").h2

    Content.is-normal(:highlight="false")
      div(v-if="$i18n.locale === 'en'")
        p Thank you for taking the time to read our legal. The following terms and conditions guide our interaction with the world whether, individuals, companies or authorities. Preaches for our legal could lead to serious consequences that could reach up to lawsuits. We maintain the right of updating our legal according to the latest organizational changes and you can visit the updates for the latest versions. You can also check our code of conduct where we share the rules that govern our business interaction with the world.
        .u-mt-xs
          AppLink(to="/books/code-of-conduct" title="See our code of conduct" class="button-link is-small") See our code of conduct

      div(v-else)
        p نشكرك على أخذ القليل من وقتك لقراءة الشروط القانونية الخاصة بنا. الشروط والأحكام التالية توجه تعاملاتنا مع العالم سواء كانوا أفراد أو شركات أو مؤسسات. قد يؤدي اهمال الالتزام بالقوانين الخاصة بنا إلى عواقب وخيمة تصل إلى الدعاوى القضائية. نحتفظ بالحق في تحديث القوانين الخاصة بنا وفقًا لأحدث التغييرات والتحديثات ويمكنك زيارة التحديثات بأحدث الاإصدارات. يمكنك أيضًا التحقق من قواعد السلوك المهني الخاص بنا حيث نتشارك معكم القواعد التي تحكم تفاعلنا التجاري مع العالم.
        .u-mt-xs
          AppLink(to="/books/code-of-conduct" title="تعرف على قواعد بيانات للسلوك المهني"  class="button-link is-small") تعرف على قواعد بيانات للسلوك المهني

</template>

<script>
export default {
  scrollToTop: true
};
</script>

<i18n>
{
  "en": {
    "mantra": "Overview"
  },
  "ar": {
    "mantra": "نظرة عامة "
  }
}
</i18n>
